/******************************************************
 *                  Admin Export Ctrl
 ********************************************************/

"use strict";

angular.module("open-iti")

	.controller("OpenPublicationCtrlSettings", [
		"$scope", "settings", "OpenPublicationService", "Utils", "$location", "toastr", "$http", "ENV",
		function ($scope, settings, OpenPublicationService, Utils, $location, toastr, $http, ENV) {

		$scope.data = {
			settings: settings.data.openDataPublication,
			urlPublicWebpage: ENV.BACKEND_PUBLIC_OPEN_DATA + "/" + settings.data.schemaName
		};

		$scope.uploadLogoFile = function(files) {
		  if (files && files.length > 0) {
			  if (files[0].size > 100000) {
				  toastr.error("Le poid de votre image est trop important.", "Taille de votre Logo");
				  angular.element("input[type='file']").val(null);
			  }
		  }
		};

		$scope.uploadImageBackgroundFile = function(files) {
			if (files && files.length > 0) {
				if (files[0].size > 10000000) {
					toastr.error("Le poid de votre image est trop important.", "Taille de votre Image de fond");
					angular.element("input[type='file']").val(null);
				}
			}
		};

		$scope.putSettings = function (data) {

			OpenPublicationService.putSettings(data)
				.then(() => {
					toastr.success("<a target='_blank' href='" + $scope.data.urlPublicWebpage + "'>Consulter la page publique dès à présent</a>", "Vos informations ont été modifiée avec succès", {allowHtml: true});

					$location.path("/open-iti/publication");
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la mise à jour de vos informations.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});

		};

	}]
	)
;
